if (!customElements.get('m-product-form')) {
  customElements.define(
    'm-product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      
        this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.bundle_toggler = document.querySelector('.js-bundle-checkbox');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const cartItems = event.cartData.items;
          if (cartItems) {
            const upsellItems = cartItems.filter((item) => item.properties._parentVariantId);
            upsellItems.forEach((item)=> {
              const hasParent = cartItems.find(line_item => line_item.id === item.properties._parentVariantId);
              if (!hasParent) {
                const formData = {
                  updates: {
                    [item.id]: 0,
                    },
                  sections: this.cart.getSectionsToRender().map((section) => section.id)
                }
            
                const config = {
                  credentials: 'same-origin',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                  },
                  body: JSON.stringify(formData)
                }
  
                fetch(`${routes.cart_update_url}.js`, config).then(response => response.json()).then((data)=> {
                  const sections = data.sections;
                  for ( let property in sections ) {
                    if(property === 'cart-drawer') {
                      const el = document.getElementById(`${property}`);
                      const parser =  new DOMParser().parseFromString(sections[property], 'text/html');
                      el.innerHTML = parser.getElementById(`${property}`).innerHTML;
                    } else {
                      const el = document.getElementById(`${property}`);
                      const parser =  new DOMParser().parseFromString(sections[property], 'text/html');
                      el.innerHTML = parser.getElementById(`shopify-section-${property}`).innerHTML;
                    }
                  }
  
                  setTimeout(()=> {
                    let cartEl = null;
                    if (this.cart.querySelector('#CartDrawer-Overlay')) {
                      cartEl = this.cart    
                      document.body.classList.add('overflow-hidden');
                      cartEl.querySelector('#CartDrawer-Overlay').addEventListener('click',()=> {
                        cartEl.classList.remove('active');
                          document.body.classList.remove('overflow-hidden');
                      });
                    } else {
                      cartEl = this.cart.querySelector('#cart-notification');
                      cartEl.addEventListener(
                        'transitionend',
                        () => {
                          cartEl.focus();
                        },
                        { once: true }
                      );
        
                      document.body.addEventListener('click', this.onBodyClick);
                    }
                    cartEl.classList.add('animate', 'active');
                  }, 250)
                }).catch((e) => {
                  console.error(e);
                })
              }
            })
  
            if(cartItems.length === 1 && cartItems[0].properties._parentVariantId) {
              this.cart.classList.add('is-empty')
            }
          }
        });
      }

      onSubmitHandler(evt) {
       if(this.bundle_toggler.classList.contains('active')) {
          this.addBundledProduct(evt);
        } else {
          this.addSimpleProduct(evt)
        }
      }

      addSimpleProduct(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            document.querySelector('#cart-notification-product').classList.remove('two-items');
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      addBundledProduct(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const productId = this.form.querySelector('[name="id"]').value;
        const bundleId = this.bundle_toggler.dataset.variantId;
        const variants =[...document.querySelectorAll(`[form="product-form-${this.dataset.sectionId}"]`)];
        const activeVariantSize = variants.find(v => v.checked).value;
        const activeVariantColor = this.form.querySelector('[name="properties[Color]"]').value;
        const formData = {
          items:[
            {
              id: Number(productId),
              quantity: 1,
              properties: {
                Color: activeVariantColor,
                _hasPersonalPhoto: true
              }
            },
            {
              id : Number(bundleId),
              quantity: 1,
              properties: {
                _parentVariantId:  Number(productId),
                personalPhoto: `For ${this.dataset.productTitle}; Size: ${activeVariantSize}; Color: ${activeVariantColor}`
              }
            }
          ],
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        }
        const config = {
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(formData)
        }

        this.cart.setActiveElement(document.activeElement);

        fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((data) => {
          let item_ids = [];
          data.items.forEach((item)=> {
            const id = `cart-notification-product-${item.key}`;
            item_ids.push(id);
          })
          const sections = data.sections;
          for ( let property in sections ) {
            if(property === 'cart-drawer') {
              const el = document.getElementById(`${property}`);
              const parser =  new DOMParser().parseFromString(sections[property], 'text/html');
              el.innerHTML = parser.getElementById(`${property}`).innerHTML;
            } else if (property === 'cart-notification-product'){
              const el = document.getElementById(`${property}`);
              const parser =  new DOMParser().parseFromString(sections[property], 'text/html');
              const product_items = parser.querySelectorAll('.cart-item');
              product_items.forEach((item)=> {
                if(item.id !== item_ids[0] && item.id !== item_ids[1]) {
                 item.remove();
                }
              })
              el.innerHTML = parser.getElementById(`shopify-section-${property}`).innerHTML;
              el.classList.add('two-items')
            } else {
              const el = document.getElementById(`${property}`);
              const parser =  new DOMParser().parseFromString(sections[property], 'text/html');
              el.innerHTML = parser.getElementById(`shopify-section-${property}`).innerHTML;
            }
          }

          setTimeout(()=> {
            let cartEl = null;
            if (this.cart.querySelector('#CartDrawer-Overlay')) {
              cartEl = this.cart    
              document.body.classList.add('overflow-hidden');
              cartEl.querySelector('#CartDrawer-Overlay').addEventListener('click',()=> {
                cartEl.classList.remove('active');
                  document.body.classList.remove('overflow-hidden');
              });
            } else {
              cartEl = this.cart.querySelector('#cart-notification');
              cartEl.addEventListener(
                'transitionend',
                () => {
                  cartEl.focus();
                },
                { once: true }
              );

              document.body.addEventListener('click', this.onBodyClick);
            }
            cartEl.classList.add('animate', 'active');
          }, 250)
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.bundle_toggler.classList.remove('active')
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.cart && !target.closest('cart-notification')) {
          const disclosure = target.closest('details-disclosure, header-menu');
          this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
          this.close();
        }
      }

      close() {
        document.querySelector('#cart-notification').classList.remove('active');
        document.body.removeEventListener('click', this.onBodyClick);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
